// extracted by mini-css-extract-plugin
export default {"button_share":"ButtonShare_button_share__idUZv","toast":"ButtonShare_toast__-ECQn"};